import { post, request } from '../api';

export interface ProjectSummary {
  id: string;
  name: string;
  status: string;
  taskCount: number;
}

export interface BusinessListItem {
  id: string;
  name: string;
  slug: string;
  taskPrefix: string;
  language: string;
  currency: string;
  timezone: string;
  status: string;
  memberCount: number;
  openTaskCount: number;
  projects: ProjectSummary[];
}

export interface BusinessMember {
  actorId: string;
  type: 'human' | 'agent';
  displayName: string;
  email: string | null;
}

export interface BusinessInput {
  name: string;
  slug: string;
  taskPrefix?: string;
  language: string;
  currency: string;
  timezone: string;
}

export interface BusinessUpdateInput {
  name?: string;
  slug?: string;
  taskPrefix?: string;
  language?: string;
  currency?: string;
  timezone?: string;
  status?: string;
}

export const businessesApi = {
  list: () => request<BusinessListItem[]>('/businesses'),
  create: (input: BusinessInput) => post<BusinessListItem>('/businesses', input),
  update: (id: string, input: BusinessUpdateInput) => request<BusinessListItem>(`/businesses/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  members: (id: string) => request<BusinessMember[]>(`/businesses/${id}/members`),
  setMembers: (id: string, actorIds: string[]) => request<BusinessMember[]>(`/businesses/${id}/members`, { method: 'PUT', body: JSON.stringify({ actorIds }) }),
  createProject: (id: string, name: string) => post<ProjectSummary>(`/businesses/${id}/projects`, { name }),
};
